import { TurboMountController } from "turbo-mount";
import { eventEmitter } from "../utils/eventEmitter";

export default class extends TurboMountController {
  get componentProps() {
    return {
      ...this.propsValue,
    };
  }

  // Dans un autre contrôleur qui pourrait exister sur une autre page
  connect() {
    super.connect()
    document.addEventListener("content_medium_edit:saved", this.handleEditSaved);
    document.addEventListener("content_medium:selected", this.handleMediaSelected);
    document.addEventListener("content_medium_edit:rendering", this.handleEditRendering);
  }

  disconnect() {
    super.disconnect()
    document.removeEventListener("content_medium_edit:rendering", this.handleEditRendering);
    document.removeEventListener("content_medium_edit:saved", this.handleEditSaved);
    document.removeEventListener("content_medium:selected", this.handleMediaSelected);
  }


  handleEditSaved = (event) => eventEmitter.emit('editSaved', event.detail)
  handleMediaSelected = (event) => { eventEmitter.emit('mediaSelected', event.detail) }
  handleEditRendering = (event) => { eventEmitter.emit('editRendering', event.detail) }
}
